<template>
  <!-- 表单盒子 -->
  <div class="row-box">
    <div class="row-title">
      <div class="row-title-left">{{ title }}</div>
      <div class="row-title-right" v-if="rightTitle" v-html="rightTitle">
        {{ rightTitle }}
      </div>
    </div>
    <div class="row-info">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-form',
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default() {
        return '';
      },
    },
    rightTitle: {
      type: String,
      default() {
        return '';
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/common';
@import '@/assets/style/theme';
@import '@/assets/style/1px';
.app-form {
  width: 100%;
}
.row-box {
  border-radius: 6px;
  background: #fff;
  margin-bottom: 12px;
  .row-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    padding: 12px;
    position: relative;
    &:after {
      @include setBottomLine(#ececec);
    }
    display: flex;
    justify-content: space-between;
    .row-title-left {
      font-weight: 600;
    }
    .row-title-right {
      color: #777777;
      font-size: 14px;
      span {
        color: #2c2c2c;
        margin: 0 2px;
        font-weight: 500;
      }
    }
    &.b-1px {
      // 安卓兼容
      &:after {
        bottom: 0.5px;
      }
    }
  }
  .row-info {
    padding: 0 12px;
    &.pb12 {
      padding-bottom: 12px;
    }
  }
}
</style>

